import { render, staticRenderFns } from "./institution-evol-chart.vue?vue&type=template&id=d1feed7c&scoped=true&lang=pug&"
import script from "./institution-evol-chart.vue?vue&type=script&lang=ts&"
export * from "./institution-evol-chart.vue?vue&type=script&lang=ts&"
import style0 from "./institution-evol-chart.vue?vue&type=style&index=0&id=d1feed7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1feed7c",
  null
  
)

export default component.exports